import {
  FaAmbulance,
  FaBuilding,
  FaCarSide,
  FaFireExtinguisher,
  FaHospital,
  FaPhoneAlt,
  FaShieldAlt,
} from "react-icons/fa";
import "../css/emergencyNumber.css";
import NavBar from "./nav";
import Footer from "./footer";

const emergencyServices = [
  {
    title: "Municipality",
    description: "Municipal support and city services.",
    icon: FaBuilding,
    tone: "navy",
    numbers: ["053-830-6100", "053-830-6911"],
  },
  {
    title: "Kimberley SAPS Central",
    description: "Police station and public safety assistance.",
    icon: FaShieldAlt,
    tone: "blue",
    numbers: ["053-838-5500", "053-839-7715/6", "053-839-7724"],
  },
  {
    title: "Fire Department",
    description: "Fire response and rescue support.",
    icon: FaFireExtinguisher,
    tone: "red",
    numbers: ["053-832-4211"],
  },
  {
    title: "Emergency Services",
    description: "Urgent city emergency response lines.",
    icon: FaPhoneAlt,
    tone: "amber",
    numbers: ["053-832-4214", "053-832-4215"],
  },
  {
    title: "Traffic Department",
    description: "Traffic incidents, roads, and local transport support.",
    icon: FaCarSide,
    tone: "teal",
    numbers: ["053-830-6220", "053-830-6034/5/6"],
  },
  {
    title: "Ambulance Services",
    description: "Private emergency medical response contacts.",
    icon: FaAmbulance,
    tone: "green",
    numbers: ["Emer-G-Med: 086-100-7911", "ER24: 084-124"],
  },
  {
    title: "Hospitals",
    description: "Hospitals and medical facilities in Kimberley.",
    icon: FaHospital,
    tone: "purple",
    featured: true,
    numbers: [
      "Provincial Hospital: 053-802-9111",
      "Medicross: 053-830-4200",
      "MediClinic Gariep: 053-838-1111",
      "Lenmed Royal Hospital: 053-045-0350",
      "Kimmed Private Hospital: 053-807-7100",
    ],
  },
];

const getDialHref = (number) => {
  const phone = number.split(":").pop().replace(/[^\d+]/g, "");
  return phone ? `tel:${phone}` : undefined;
};

const EmergencyNumber = () => {
  return (
    <div className="emergency-page">
      <NavBar />

      <section className="hero-section emergency-hero">
        <div className="hero-content">
          <h1 className="hero-title">Emergency Numbers</h1>
          <p className="hero-subtitle">
            Quick access to important Kimberley emergency and support contacts.
          </p>
        </div>
      </section>

      <main className="emergency-shell">
        <section className="emergency-intro">
          <div>
            <p className="emergency-eyebrow">Kimberley safety directory</p>
            <h2>Emergency Numbers - Kimberley</h2>
            <p>
              Contact the relevant service below. Tap any number to start a call
              on supported devices.
            </p>
          </div>

          <div className="emergency-priority-card">
            <span>
              <FaPhoneAlt />
            </span>
            <div>
              <strong>Keep this page close</strong>
              <p>Useful contacts for police, fire, ambulance, traffic, and hospitals.</p>
            </div>
          </div>
        </section>

        <section className="emergency-grid" aria-label="Emergency contact cards">
          {emergencyServices.map((service) => {
            const Icon = service.icon;

            return (
              <article
                className={`emergency-card ${
                  service.featured ? "featured" : ""
                }`}
                key={service.title}
              >
                <div className="emergency-card-top">
                  <span className={`emergency-icon ${service.tone}`}>
                    <Icon />
                  </span>
                  <div>
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                  </div>
                </div>

                <div className="emergency-number-list">
                  {service.numbers.map((number) => (
                    <a href={getDialHref(number)} key={number}>
                      <FaPhoneAlt />
                      <span>{number}</span>
                    </a>
                  ))}
                </div>
              </article>
            );
          })}
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default EmergencyNumber;
